import React from "react"
import Typography from "@material-ui/core/Typography"
import { KeywordTypography } from ".."
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
    },
    name: {
      color: props => theme.palette[props.color].main,
      marginBottom: theme.spacing(3),
    },
    cbdQuantity: {
      color: props => theme.palette[props.color].main,
    },
    price: {
      fontWeight: "bold",
      marginBottom: theme.spacing(2),
      marginTop: "auto",
      paddingTop: theme.spacing(4),
    },
    paragraphs: {
      flexShrink: 1,
      textOverflow: "elipsis",
    },
    price_wrapper: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "flex-start",
    },
    out_of_stock: {
      marginLeft: theme.spacing(3),
      paddingTop: theme.spacing(4),
      lineHeight: "34px",
      color: theme.palette["red"].main,
      textTransform: "uppercase",
    },
  }
})

export default props => {
  const classes = useStyles(props)
  // const mapParagraphs = paragraphs =>
  //   paragraphs.map((paragraph, i) => <KeywordTypography keywords={props.keywords}key={i} variant={'body1'}>{paragraph}</KeywordTypography>)
  return (
    <div className={classes.root}>
      <Typography classes={{ root: classes.name }} variant={"h3"} component={"h1"}>
        {props.name}
      </Typography>
      <Typography classes={{ root: classes.cbdQuantity }} variant={"h4"} component={"h2"}>
        {props.volume + ", " + props.cbdQuantity}
      </Typography>
      <KeywordTypography keywords={props.keywords} variant={"body1"}>{props.description}</KeywordTypography>
      {props.langKey === "es" && <div className={classes.price_wrapper}>
        <Typography classes={{ root: classes.price }} variant={"h4"} component={"h3"}>
          {props.price}
        </Typography>
        {props.isOutOfStock &&
        <Typography classes={{ root: classes.out_of_stock }} variant={"span"} component={"span"}>
          {props.outOfStock}
        </Typography>
        }
      </div>
      }
    </div>
  )
}
